module.exports = __webpack_public_path__ + "img/orangeMoney.8f819c2a.png";